/* eslint-disable react/function-component-definition */
import React, { AnchorHTMLAttributes } from "react";
import DesignSystemButton, {
  StandardButtonProps,
} from "./StandardButton.component";

export type ButtonLinkAnchorProps = AnchorHTMLAttributes<HTMLAnchorElement> &
  StandardButtonProps;

export function LinkAnchorButton({
  className,
  children,
  icon,
  rightIcon,
  label,
  size,
  type,
  disabled,
  justify,
  labelHidden,
  loading,
  ...props
}: ButtonLinkAnchorProps) {
  const withNoOpener = {
    href: props.href,
    target: props.target,
    rel: props.rel,
  };
  if (/^https?:\/\//i.test(withNoOpener.href || "") && !withNoOpener.target) {
    withNoOpener.target = "_blank";
  }
  if (withNoOpener.target === "_blank") {
    withNoOpener.rel = "noopener noreferrer";
  }

  return (
    <a {...withNoOpener}>
      <DesignSystemButton
        {...props}
        label={label}
        size={size}
        type={type}
        icon={icon}
        rightIcon={rightIcon}
        disabled={disabled}
        justify={justify}
        labelHidden={labelHidden}
        loading={loading}
        className="w-full"
      >
        {children}
      </DesignSystemButton>
    </a>
  );
}

export default LinkAnchorButton;
